import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseAppointmentScheduleGetProps {
  appointmentId: number;
  enabled?: boolean;
}

export const useAppointmentScheduleGet = ({
  appointmentId,
  enabled = true,
}: IUseAppointmentScheduleGetProps) => {
  const accessToken = useAccessToken();

  const { 
    data, 
    isError, 
    isLoading, 
    isSuccess, 
    isPending,
    refetch,
  } = useQuery({
    queryKey: [QueryKeys.AppointmentSchedule, appointmentId],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        PrivatesAppointmentsApi,
        accessToken,
      );
      return service.apiAppointmentsIdScheduleGet({
        id: appointmentId,
      });
    },
    enabled: enabled && appointmentId > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
    retry: false, // 400 from backend = bad request; don't retry
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};
